import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { PartnerTrainingLibraryPage } from '@/features/partner-training/library-page'

export const Route = createFileRoute('/_authenticated/_organization/partner/training/')({
  beforeLoad: async () => {
    await requireRoles(['owner', 'admin', 'team_leader', 'finance'])
    await requireActiveSubscription()
  },
  component: PartnerTrainingLibraryPage,
})
